import { styled } from '@mui/material/styles';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link } from '../../Link';

export default function BackButton({ href, text }: { href: string; text: string }) {
  return (
    <StyledButtonContainer>
      <StyledBackButton href={href}>
        <StyledArrowBack />
        <StyledBackText>{text}</StyledBackText>
      </StyledBackButton>
    </StyledButtonContainer>
  );
}

const StyledButtonContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const StyledBackButton = styled(Link)`
  display: flex;
  height: 30px;
  padding-left: 18px;
  padding-right: 22px;
  column-gap: 11px;
  min-width: 220px;
  width: fit-content;
  border-radius: 4px;
  margin-bottom: 7px;
  align-items: center;
  text-decoration: none;
  font-weight: 700;
`;

const StyledBackText = styled('div')`
  font-size: 13px;
  line-height: 13px;
  white-space: nowrap;
`;

const StyledArrowBack = styled(ArrowBackIcon)`
  width: 16px;
`;
